export default __webpack_public_path__ + "static/media/Veggie.eed144a7.svg";